import Header from "./components/ui/Header";
import Searchbar from './components/ui/Searchbar';



const App = () => {

  return ( 
    <div className="App container-fluid">
      <Header />
      <Searchbar/>
    </div>
   );
}
 
export default App;
